// Styled.
import styled from 'styled-components';

export const Languages = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
`;

export const Button = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  color: var(--navbar-menu-link);
  border: none;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  > svg {
    width: 16px;
    height: 16px;
    fill: var(--link);
    color: var(--link);
    margin-right: 0 !important;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;

    > img {
      margin-right: var(--xs-padding-horizontal);
      width: 16px;
    }
  }
`;

export const Divider = styled.div`
  width: auto;
  height: 1px;
  margin: 0 var(--xs-padding-horizontal);
  background-color: var(--navbar-menu-border-color);
`;
